import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FormlyFieldConfig } from '@ngx-formly/core';

@Component({
  selector: 'tks-cominication',
  template: `
   <p>{{pasos}}</p>
    <form
      style="margin-top: 50px;"
      [formGroup]="formLogin"
      (ngSubmit)="onSubmit()">
      <formly-form
          [form]="formLogin"
          [fields]="fieldsLogin"
          [model]="modelLogin"></formly-form>
      <br><br>
     <a
        href="#"
        class="olvido-contrasena"
        style="color: #3c3c7f;">¿Olvidaste la contraseña?</a>
      <br><br><br>
          <button
              type="submit"
              expand="block"
              class="secondButton">Iniciar sesión</button>
    </form>
  `,
  styles: [
  ]
})
export class CominicationComponent implements OnInit {

  @Input() pasos:boolean = true;
  @Output() comunica = new EventEmitter<boolean>();

  model = {
    email: '',
    password: ''
  };
  form = [
      {
          key: 'email',
          type: 'input',
          templateOptions: {
              placeholder: 'Correo/Telefono',
              required: true,
          }
      },
      {
          key: 'password',
          type: 'input',
          templateOptions: {
              type: 'password',
              placeholder: 'Contraseña',
              required: true,
          }
      },

  ];

  formLogin = new FormGroup({});
  modelLogin = this.model;
  fieldsLogin: FormlyFieldConfig[] = this.form;
  constructor() { }

  ngOnInit(): void {
  }
  onSubmit(){
    console.log(this.modelLogin);
    this.pasos = true
    this.comunica.emit( this.pasos);
  }

}
